import { createReducer } from '../../store';
import {
  GET_FORM_PRINTS_REQUEST,
  GET_FORM_PRINTS_RESPONSE,
  GET_FORM_PRINTS_FAILURE,
} from './actions-definitions';

const initialState = {
  isLoading: false,
  prints: [],
};

export default createReducer(initialState, {
  [GET_FORM_PRINTS_REQUEST](state) {
    return {
      ...state,
      isLoading: true,
    };
  },
  [GET_FORM_PRINTS_RESPONSE](state, action) {
    return {
      ...state,
      prints: action.prints,
      isLoading: false,
    };
  },
  [GET_FORM_PRINTS_FAILURE](state) {
    return {
      ...state,
      isLoading: false,
    };
  },
});
